(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-archive-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const main = document.querySelector('.template-index #MainContent');
    if (!main || main.dataset.sdMotionReady === 'true') return;

    main.dataset.sdMotionReady = 'true';
    document.documentElement.classList.add('sd-motion-ready');

    const hero = main.querySelector('.home-banner');
    const heroSection = hero ? hero.closest('.shopify-section') : null;
    if (heroSection) heroSection.classList.add('sd-hero-section');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = [...main.querySelectorAll('[data-sd-reveal]')];

    let directoryScrollFrame = null;
    const directoryLinks = [...main.querySelectorAll('.home-archive-directory__links a[href^="#"]')];

    directoryLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const hash = new URL(link.href, window.location.href).hash;
        const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
        if (!target) return;

        event.preventDefault();

        if (window.matchMedia('(hover: none), (pointer: coarse)').matches) {
          link.classList.add('is-pressed');
          window.setTimeout(() => {
            link.classList.remove('is-pressed');
            link.blur();
          }, 180);
        }

        const startPosition = window.scrollY;
        const announcementHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) || 0;
        const targetPosition = Math.max(0, startPosition + target.getBoundingClientRect().top - announcementHeight);
        const distance = targetPosition - startPosition;

        if (directoryScrollFrame) window.cancelAnimationFrame(directoryScrollFrame);
        window.history.pushState(null, '', hash);

        if (reducedMotion) {
          window.scrollTo(0, targetPosition);
          return;
        }

        const duration = Math.min(560, Math.max(360, Math.abs(distance) * 0.12));
        let startTime = null;

        const scrollStep = (timestamp) => {
          if (startTime === null) startTime = timestamp;
          const progress = Math.min(1, (timestamp - startTime) / duration);
          const easedProgress = 1 - Math.pow(1 - progress, 3);
          window.scrollTo(0, startPosition + distance * easedProgress);

          if (progress < 1) {
            directoryScrollFrame = window.requestAnimationFrame(scrollStep);
          } else {
            directoryScrollFrame = null;
          }
        };

        directoryScrollFrame = window.requestAnimationFrame(scrollStep);
      });
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });

    reveals.forEach((element) => observer.observe(element));

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
